module.exports = __webpack_public_path__ + "static/media/jenya_headshot.96acad3f.jpg";